import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + '/api';
const API_ENDPOINT1 = 'usaepaysale';
const API_ENDPOINT2 = 'usaepaysale-sendbox';

export function chargeCustomer(data, params) {
    let obj = {
        ...getHeaderOptions(),
        Authorization: 'Bearer ' + localStorage.getItem('token')
    }
    if (process.env.REACT_APP_ENV === 'staging') {
   return axios.post(`${API_ENDPOINT}/${API_ENDPOINT2}`, data, { headers: obj, params: params })
    } else if (process.env.REACT_APP_ENV === 'production') {
    return axios.post(`${API_ENDPOINT}/${API_ENDPOINT1}`, data, { headers: obj, params: params })  // Replace with your live script URL
    }

    
}

export function chargeCustomer1(data, params){
    let obj = {
        ...getHeaderOptions(),
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return axios.post(`${API_ENDPOINT}/Payment/cardKnoxsale`, data, {headers: obj, params: params})
}